import { useCallback } from 'react';
import { useCreateGeneralContact } from '#root/queries/generalContacts';

export const useGeneralContactOperations = () => {
    const createGeneralContact = useCreateGeneralContact();

    const createGeneralContactOperation = useCallback(async (contact: any) => {
        const generalContactResponse = await createGeneralContact.mutateAsync({
            generalContact: contact
        });

        return generalContactResponse;
    }, [createGeneralContact]);

    return {
        createGeneralContact: createGeneralContactOperation
    };
};

export type GeneralContactOperations = ReturnType<typeof useGeneralContactOperations>;
